let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gOC9l")).then(() => parcelRequire('96s91'));